import React from "react";
import "../../common/CustomProgressBar/style.css";
import { Button } from "antd";
import { CaretLeftOutlined, CaretRightOutlined } from "@ant-design/icons";

const ProgressBar = ({ progress, onNext, onPrevious, defaultWidth }) => {
  const progressBarStyle = {
    width: `${progress}%`,
    // marginLeft: progress,
  };

  return (
    <div className="progress-container">
      <div className="progress-bar">
        <div className="progress" style={progressBarStyle}></div>
      </div>
      <div className="arrows">
        <CaretLeftOutlined style={{ fontSize: 24 }} onClick={onPrevious} />
        <CaretRightOutlined style={{ fontSize: 24 }} onClick={onNext} />
      </div>
    </div>
  );
};

export default ProgressBar;
